(ns teamoesterreich.admin-mode.text-blocks.text-block-form
  (:require
    [clojure.string :as string]
    [clojure.string]
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [goog.date.DateTime]
    [teamoesterreich.admin-mode.data.backend :as backend]
    [teamoesterreich.admin-mode.text-blocks.text-block-trigger-helper :as trigger-helper]
    [teamoesterreich.admin-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.view-state :as v-state]
    [teamoesterreich.admin-mode.actions :as a]

    [teamoesterreich.admin-mode.data.text-block :as d-text-block]
    [teamoesterreich.admin-mode.component.org-selector :as org-selector]
    [teamoesterreich.admin-mode.data.rights :as d-rights]
    [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
    [teamoesterreich.admin-mode.ui-helper.line-edit-card :as line-edit-card]
    [teamoesterreich.admin-mode.ui-helper.block-edit-card :as block-edit-card]
    [teamoesterreich.admin-mode.ui-helper.sms-block-edit-card :as sms-block-edit-card]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]

    [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
    [reagent-material-ui.icons.add :refer [add]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.save :refer [save]]
    ))



(defn get-type [key]
  (or (get {:email "Email"
            :md    "Formatierter Text"
            :sms   "SMS"}
           key) (str "?" key)))


(defn name-and-org [text !invalidated edit-allowed?]
  (let [default {:name        (:toeTextBlock-name text)
                 :key         (or (:toeTextBlock-key text) "")
                 :orgId       (or (:toeTextBlock-orgIdFilter text) ".*")
                 :allow-copy  (or (:toeTextBlock-allowCopy text) false)
                 :locked      (if (false? (:toeTextBlock-locked text)) false true)
                 :active      (if (false? (:toeTextBlock-active text)) false true)
                 :description (or (:toeTextBlock-description text) "")
                 :edit-mode   false
                 :show-delete-modal? false}
        !st (r/atom default)
        !selected (r/cursor v-state/app-state [:textBlock-list :selected])
        !allowCopy (r/cursor !st [:allow-copy])
        !active (r/cursor !st [:active])
        !locked (r/cursor !st [:locked])
        !orgId (r/cursor !st [:orgId])
        !editor-mode? (r/cursor !st [:edit-mode])
        !show-copy? (r/cursor !st [:show-copy?])
        !show-delete-modal? (r/cursor !st [:show-delete-modal?])
        !name (r/cursor !st [:name])
        !key (r/cursor !st [:key])
        !description (r/cursor !st [:description])
        edit-allowed? (or (d-rights/is-superuser?) edit-allowed?)
        ]

    (fn []
      (log/debug "name-and-org" (clj->js text))
      (let [group-triggers (trigger-helper/get-group-triggers (:toeTextBlock-group text) (:toeTextBlock-type text))
            name-ch? (not= (:toeTextBlock-name text) @!name)
            key-ch? (not= (or (:toeTextBlock-key text) "") @!key)
            description-ch? (not= (:toeTextBlock-description text) @!description)
            orgId-ch? (not= (or (:toeTextBlock-orgIdFilter text) ".*") @!orgId)
            active-ch? (not= (or (:toeTextBlock-active text) false) @!active)
            locked-ch? (not= (or (:toeTextBlock-locked text) false) @!locked)
            allow-copy-ch? (not= (or (:toeTextBlock-allowCopy text) false) @!allowCopy)
            changed? (or name-ch?
                         key-ch?
                         orgId-ch?
                         description-ch?
                         locked-ch?
                         active-ch?
                         allow-copy-ch?
                         )
            on-save-fn (fn []
                         (d-text-block/set-text-block (:toeTextBlock-uuid text) {:toeTextBlock-name        @!name
                                                                                 :toeTextBlock-key         @!key
                                                                                 :toeTextBlock-description @!description
                                                                                 :toeTextBlock-orgIdFilter @!orgId
                                                                                 :toeTextBlock-locked      @!locked
                                                                                 :toeTextBlock-active      @!active
                                                                                 :toeTextBlock-allowCopy   @!allowCopy}
                                                      #(reset! !invalidated true)))]
        [mui/card
         [are-you-sure-modal/are-you-sure-modal !show-copy? "Vorlage kopieren als neue Vorlage?" "kopieren"
          (fn []
            (d-text-block/copy-text-block (:toeTextBlock-uuid text) (first (d-rights/get-rights-orgId-filter d-rights/ADMIN))
                                          (fn [textBlock]
                                            (reset! !selected (:toeTextBlock-uuid textBlock))
                                            )))]
         [mui/card-content
          {:style {:maxWidth "1000px" :textAlign "left"}}
          ;[:span (str group-triggers)]
          (if (and @!editor-mode? (d-rights/is-superuser?))
            (when (not (empty? group-triggers))
              [mui/grid
               {:item true
                :lg   4
                :md   4
                :xs   6}
               [mui/form-control
                {:fullWidth true
                 :style     {:backgroundColor (if key-ch? "#ffd6d2" "#ffffff")}}
                [mui/input-label "Trigger"]
                [mui/select
                 {:fullWidth true
                  :value     (or @!key "")
                  :onChange  (fn [e] (reset! !key (h/event-value e)))
                  :label     "Trigger"}
                 ^{:key (str "trigger-none")} [mui/menu-item {:value ""} "-"]
                 (when (and (not= @!key "")
                            (not (some #{(keyword @!key)} (mapv first group-triggers))))
                   ^{:key (str "trigger-" @!key)} [mui/menu-item {:value @!key} ":" @!key])
                 (for [[trigger trigger-name] group-triggers]
                   ^{:key (str "trigger-" trigger)} [mui/menu-item {:value (name trigger)} trigger-name])
                 ]]])

            [mui/text-field {
                             :style        {:backgroundColor (if name-ch? "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     true
                             :label        "Trigger"
                             :defaultValue (trigger-helper/get-name (:toeTextBlock-group text) (:toeTextBlock-type text) (:toeTextBlock-key text))
                             }])

          [mui/text-field {
                           :style        {:backgroundColor (if name-ch? "#ffd6d2" "#ffffff")}
                           :fullWidth    true
                           :disabled     (not @!editor-mode?)
                           :label        "Name"
                           :onChange     (fn [e] (reset! !name (h/event-value e)))
                           :defaultValue (:toeTextBlock-name text)
                           }]
          (when @!editor-mode?
            [mui/text-field {
                             :style        {:backgroundColor (if name-ch? "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!editor-mode?)
                             :label        "Beschreibung"
                             :multiline    true
                             :rows         4
                             :onChange     (fn [e] (reset! !description (h/event-value e)))
                             :defaultValue (:toeTextBlock-description text)
                             }])


          [(org-selector/get-org-selector !orgId (d-rights/get-rights-orgId-filter d-rights/ADMIN) {:border "" :paddingLeft "0px" :readonly (not @!editor-mode?)})]

          ;[:pre (string/replace (pr-str text) #", :" ",\n:")]
          ;[:pre (string/replace (pr-str @!st) #", :" ",\n:")]
          ;[:pre "allow:" (if (d-rights/allow-admin-for d-rights/ADMIN (:toeTextBlock-orgIdFilter text)) "Yes " "No")]
          ]

         [mui/card-actions
          {:style {:marginTop "15px"}}
          (if @!editor-mode?
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   #(swap! !st assoc :name (:toeTextBlock-name text) :orgId (:toeTextBlock-orgIdFilter text) :locked (:toeTextBlock-locked text) :edit-mode false)
                         }
             "Abbrechen"]

            (when edit-allowed?
              [mui/button {:variant   "contained"
                           :startIcon (r/as-element [edit])
                           :onClick   #(reset! !editor-mode? true)
                           }
               "Bearbeiten"])

            )



          (when edit-allowed?
            [mui/form-control-label
             {:style     {:paddingLeft "126px" :backgroundColor (if (true? locked-ch?) "#ffd6d2" "#ffffff")}
              :label     "aktiv"
              :fullWidth true
              :control   (r/as-element [mui/switch {:variant  "contained"
                                                    :checked  (or @!active false)
                                                    :disabled (not @!editor-mode?)
                                                    :onClick  #(reset! !active (not @!active))
                                                    }])}
             ])

          (when edit-allowed?
            [mui/form-control-label
             {:style     {:paddingLeft "126px" :backgroundColor (if (true? locked-ch?) "#ffd6d2" "#ffffff")}
              :label     "gesperrt"
              :fullWidth true
              :control   (r/as-element [mui/switch {:variant  "contained"
                                                    :checked  (or @!locked false)
                                                    :disabled (not @!editor-mode?)
                                                    :onClick  #(reset! !locked (not @!locked))
                                                    }])}
             ])

          (when (and edit-allowed? (d-rights/is-superuser?))
            [mui/form-control-label
             {:style     {:paddingLeft "126px" :backgroundColor (if (true? allow-copy-ch?) "#ffd6d2" "#ffffff")}
              :label     "Vererben erlauben"
              :fullWidth true
              :control   (r/as-element [mui/switch {:variant  "contained"
                                                    :checked  (or @!allowCopy false)
                                                    :disabled (not @!editor-mode?)
                                                    :onClick  #(reset! !allowCopy (not @!allowCopy))
                                                    }])}
             ])


          (when @!editor-mode?
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [save])
                         :disabled  (if changed? false true)
                         :color     "primary"
                         :onClick   (fn []
                                      (on-save-fn)
                                      (swap! !st assoc
                                             :key (:toeTextBlock-key text)
                                             :name (:toeTextBlock-name text)
                                             :orgId (:toeTextBlock-orgIdFilter text) :locked (:toeTextBlock-locked text) :edit-mode false))
                         }
             "Speichern"])

          (when (and (not @!editor-mode?) (:toeTextBlock-allowCopy text))
            [mui/button {:variant   "contained"
                         :disabled  (if (or (true? (:toeTextBlock-allowCopy text))) false true)
                         :startIcon (r/as-element [add])
                         :onClick   #(reset! !show-copy? true)
                         }
             "Kopieren/Vererben"])

          [ays-modal/are-you-sure-modal !show-delete-modal? "Willst du wirklich diese Vorlage löschen?" "Löschen"
           (fn [] (d-text-block/drop-text-block (:toeTextBlock-uuid text)
                                                #(a/set-page :text-blocks)))]

          (when (d-rights/allow-admin-for d-rights/CONTENT (:toeTextBlock-orgIdFilter text))
            [:span {:title (if (or (:toeTextBlock-locked text) (:toeTextBlock-locked text)) "Löschen nur möglich wenn nicht aktiv und nicht gesperrt" "")}
             [mui/button {:variant   "contained"
                          :disabled  (not edit-allowed?)
                          :startIcon (r/as-element [delete-forever])
                          :onClick   #(reset! !show-delete-modal? true)
                          }
              "Löschen"]])

          ]

         ]
        )

      )))



(defn text-block-card [!st text]

  (let [
        edit-allowed? (d-rights/allow-admin-for d-rights/ADMIN_CONTENT (:toeTextBlock-orgIdFilter text))

        !meta-change (r/cursor !st [:meta-change])
        !invalidated (r/cursor !st [:invalidated])
        !edit-description (r/cursor !st [:edit-description])
        uuid (get text :toeTextBlock-uuid)
        type (get text :toeTextBlock-type)
        changed? (fn [key] (and (exists? (get @!meta-change key)) (not= (get @!meta-change key) (get text key))))
        has-changes? (or
                       (changed? :toeTextBlock-group)
                       (changed? :toeTextBlock-name)
                       (changed? :toeTextBlock-type)
                       )

        save-text-fn (fn [content]
                       (d-text-block/set-text-block uuid {:toeTextBlock-content content}
                                                    #(reset! !invalidated true)))
        save-subject-fn (fn [content] (d-text-block/set-text-block uuid {:toeTextBlock-subject content}
                                                                   #(reset! !invalidated true)))
        save-description-fn (fn [content] (d-text-block/set-text-block uuid {:toeTextBlock-description content}
                                                                       #(reset! !invalidated true)))
        ]

    [mui/card {:style {:marginTop "10px"}}

     [mui/card-header
      {:style {:text-align "left"} :title (str (get (:groups @!st) (get text :toeTextBlock-group)) " - " (get text :toeTextBlock-name) " - " (get-type (keyword (get text :toeTextBlock-type))))}]


     [mui/card-content {:style {:textAlign "left" :marginLeft "20px"}}


      [(name-and-org text !invalidated edit-allowed?)]


      (if edit-allowed?
        (cond
          (= type "md")
          [(edit-md-card/get-it (get text :toeTextBlock-content) save-text-fn (str backend/BASE_URL "/document"))]

          (= type "email")
          [:div
           [(line-edit-card/get-it (get text :toeTextBlock-subject) save-subject-fn "Betreff")]
           [(edit-md-card/get-it (get text :toeTextBlock-content) save-text-fn (str backend/BASE_URL "/media-upload") "Inhalt")]]

          (= type "line")
          [(line-edit-card/get-it (get text :toeTextBlock-content) save-text-fn)]

          (= type "block")
          [(block-edit-card/get-it (get text :toeTextBlock-content) save-text-fn)]

          (= type "sms")
          [(sms-block-edit-card/get-it (get text :toeTextBlock-content) save-text-fn)]

          :else
          (if (> (count (get text :toeTextBlock-content)) 200)
            (str (subs (get text :toeTextBlock-content) 0 200) "...")
            (get text :toeTextBlock-content))

          )

        (cond
          (= type "email")
          [:div
           [:h4 "Betreff"]
           [:div {:dangerouslySetInnerHTML {:__html (str "" (get text :toeTextBlock-subject))}}]
           [:h4 "Inhalt"]
           [:div {:dangerouslySetInnerHTML {:__html (str "" (get text :toeTextBlock-content))}}]
           ]

          :else
          [:div
           [:h4 "Inhalt"]
           [:div {:dangerouslySetInnerHTML {:__html (str "" (get text :toeTextBlock-content))}}]]

          )
        )
      ]
     [mui/card-content {:style {:textAlign "left" :marginLeft "20px"}}
      [:pre (str "" (get text :toeTextBlock-description))]]


     [mui/card-actions
      [mui/button {:variant   "contained"
                   :startIcon (r/as-element [keyboard-arrow-left])
                   :onClick   #(a/set-page :text-blocks)
                   }
       "Zurück"]
      ]
     ]

    ))

(defn get-it []
  (let [!st (r/atom {:invalidated true :data {} :opened nil :showHelp false :meta-change {} :group ""})
        !selected (r/cursor v-state/app-state [:textBlock-list :selected])
        !invalidated (r/cursor !st [:invalidated])
        !data (r/cursor !st [:data])]
    (fn []
      (js/console.log "!data " (clj->js (get @!data @!selected)))
      (when-not @!selected (a/set-page :text-blocks))
      (if @!invalidated
        (do
          (swap! v-state/app-state dissoc :text-blocks)
          (d-text-block/get-text-blocks
            (fn [response]
              (swap! !st assoc :invalidated false :data response)
              ))
          [mui/paper
           [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
           [mui/typography {} "Lade Daten ... "]
           ]
          )

        ;[:div "lallala 22" ]
        [text-block-card !st (get @!data @!selected)]

        )

      )))
